import {useTransition} from '@logistics-frontend/blocks'
import type {ServerError} from '@logistics-frontend/core/utils/network'
import {useCallback} from 'react'

import {fetchDetectLocationDeprecated} from 'src/shared/api'
import type {LocationDetectedVariant} from 'src/shared/types'

export function useFetchDetectLocation() {
  const [{payload, isPending}, startTransition] = useTransition<LocationDetectedVariant[], ServerError>(undefined, {
    key: 'detect-location',
  })

  const fetchDetectLocationHandler = useCallback((location?: string) => {
    if (location === undefined) {
      return
    }

    startTransition(() => fetchDetectLocationDeprecated({location}))
  }, [])

  return {
    isDetectLocation: isPending,
    locations: payload,
    fetchDetectLocationHandler,
  }
}
